import RuffleHero from "../components/RuffleHero";
import ServiceHighlights from "../components/ServiceHighlights";
import FeaturedProducts from "../components/FeaturedProducts";
import TestimonialMarquee from "../components/TestimonialMarquee";
import CartoonStrip from "../components/CartoonStrip";
import NewsletterStrip from "../components/NewsletterStrip";
import TributeStrip from "../components/TributeStrip";
import { Link } from "react-router-dom";
import usePageMeta from "../hooks/usePageMeta";

export default function Home() {
  usePageMeta({title:"Legendary Erotic Hypnotist",description:"London-based British erotic hypnotist with a crisp English accent. In-person erotic hypnosis sessions and consensual fly-on-the-wall videos. Discreet, professional, Adults 18+.",path:"/"});
  return (
    <div data-testid="page-home">
      <RuffleHero />

      {/* Intro */}
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="md:col-span-7">
            <div className="eyebrow mb-5">Welcome</div>
            <p className="font-serif text-2xl md:text-4xl text-cream/90 leading-snug">
              I am a London-based British erotic hypnotist with a crisp English accent, offering deeply immersive <em className="text-gold">in-person erotic hypnosis</em> and professionally recorded fly-on-the-wall videos of consenting sessions. Every session is guided with explicit consent, professionalism and tailored aftercare.
            </p>
            <div className="mt-10 flex gap-6 items-center">
              <Link to="/about" className="link-gold text-xs uppercase tracking-[0.22em]" data-testid="home-about-link">
                Read the full story →
              </Link>
            </div>
          </div>
          <div className="md:col-span-5">
            <figure className="relative aspect-square max-w-sm mx-auto md:ml-auto md:mr-0">
              <div className="absolute inset-0 -rotate-2 border border-[#c9a04b]/30 pointer-events-none" />
              <div className="relative w-full h-full overflow-hidden border border-[#c9a04b]/25">
                <img
                  src="https://customer-assets.emergentagent.com/job_trance-bookings/artifacts/9kie8vt6_Cleopatra%20uk%20erotic%20hypnosis.jpg"
                  alt="Queen Cleopatra with hypno-spiral glasses and gold pocket watch"
                  className="w-full h-full object-cover"
                />
              </div>
              <figcaption className="absolute -bottom-5 right-2 eyebrow text-cream/55">A study in surrender</figcaption>
            </figure>
          </div>
        </div>
      </section>

      <ServiceHighlights />

      <FeaturedProducts />

      <div id="newsletter">
        <NewsletterStrip source="my-pleasure-preview" />
      </div>

      <CartoonStrip />

      <TestimonialMarquee />

      <TributeStrip />
    </div>
  );
}
